export default "__VITE_ASSET__Bib2dKrE__"